! function(e, n) {
  var t = {
    get: function(e) {
      if (n.cookie.length > 0) {
        var t = n.cookie.indexOf(e + "=");
        if (-1 != t) {
          t = t + e.length + 1;
          var o = n.cookie.indexOf(";", t);
          return -1 == o && (o = n.cookie.length), unescape(n.cookie.substring(t, o))
        }
      }
      return ""
    },
    set: function(e, t, o, i) {
      var c = new Date;
      c.setDate(c.getDate() + o), n.cookie = e + "=" + escape(t) + ("undefined" == typeof o ? "" : "; expires=" + c.toUTCString()) + ("undefined" == typeof i ? "; path=/" : "; path=" + i)
    },
    check: function(e) {
      return e = t.get(e), null !== e && "" !== e ? !0 : !1
    }
  };
  e.jsCookies = t
}(window, document);

define("cookie-plugin", function(){});

